<ng-content select="[header]"></ng-content>
<form autocomplete="off" [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="verification-template-root">
  <div class="title">
    <ng-content select="[title]"></ng-content>
  </div>
  <div class="instructions">
    <ng-content select="[instructions]"></ng-content>
  </div>
  <div class="image">
    <ng-content select="[image]"></ng-content>
  </div>
  <div class="verification-email">
    <ng-content select="[verificationEmail]"></ng-content>
  </div>
  <div class="code-title">
    <ng-content select="[codeTitle]"></ng-content>
  </div>
  <div class="code-area">
    <ng-content select="[codeInput]"></ng-content>
  </div>
  <div class="message">
    <ng-content select="[message]"></ng-content>
  </div>
  <div class="bullet-points">
    <ng-content select="[bulletPoints]"></ng-content>
  </div>
  <ng-content select="[buttonSection]"></ng-content>
</form>
